import * as React from 'react'

import { AttachmentModel } from '../../domain/model'
import UploadedFile from './uploaded-file'
import { AttachmentTranslations } from '../../translations'

interface FileViewerProps {
  models: AttachmentModel[]
  onDelete?: (model: AttachmentModel) => void
  authProfile: string
  attachmentApiUrl: string
  translations: AttachmentTranslations
}
function FileViewer(props: FileViewerProps) {
  return (
    <div className="file-viewer">
      {props.models.map((model) => (
        <UploadedFile
          key={model.id}
          model={model}
          onDelete={props.onDelete}
          authProfile={props.authProfile}
          attachmentApiUrl={props.attachmentApiUrl}
          translations={props.translations}
        />
      ))}
    </div>
  )
}
export default FileViewer
